export default {
	SET_HOMEWORK_LIST(state, payload) {
		state.list = payload.themes;
		state.id = payload.id;
		state.date = payload.date;
	},
	PUT_HOMEWORK_ITEM_BY_KEY(state, payload) {

		const {
			index,
			theme
		} = payload;

		state.list[index] = theme;

	}
};



// WEBPACK FOOTER //
// ./sources/domains/homework/mutations.js